import { createRouter, createWebHashHistory } from "vue-router";

const site = process.env.VUE_APP_SITE;

/**
 * 路由設定資料表
 * path:
 *   - 有指定時直接使用
 *   - 沒指定時自動組成 /{group}/{name}
 *
 * file:
 *   - 對應的 vue 檔名
 *   - 沒指定時預設使用 name
 */
const routeConfigs = [
  {
    path: "/",
    name: "index",
    file: "IndexView",
  },

  // launchSuite
  {
    group: "launchSuite",
    name: "advance",
  },
  {
    group: "launchSuite",
    name: "beginner",
  },
  {
    group: "launchSuite",
    name: "custom",
  },

  // systemCenter
  {
    group: "systemCenter",
    name: "frontendOverview",
  },
  {
    group: "systemCenter",
    name: "backendConsole",
  },
  {
    group: "systemCenter",
    name: "gameSetup",
  },

  // kumaDNA
  {
    group: "kumaDNA",
    name: "kumaOverview",
  },
  {
    group: "kumaDNA",
    name: "expoFootprints",
  },

  // partnerHub
  {
    group: "partnerHub",
    name: "partnerBrands",
  },
  {
    group: "partnerHub",
    name: "campaignPush",
  },
  {
    group: "partnerHub",
    name: "tagStudio",
  },

  // smartSupport
  {
    group: "smartSupport",
    name: "privacyPolicy",
  },
];

/**
 * 動態產生 routes
 */
const routes = routeConfigs.map(({ path, group, name, file = name }) => ({
  path: path || `/${group}/${name}`,
  name,

  component: () => {
    // 首頁
    if (!group) {
      return import(
        /* webpackChunkName: "index" */
        `../views/${site}/${file}.vue`
      );
    }

    // 其餘頁面
    return import(`../views/${site}/${group}/${file}.vue`);
  },
}));

const router = createRouter({
  history: createWebHashHistory(),

  routes,

  linkActiveClass: "active",

  scrollBehavior(to, from, savedPosition) {
    // 瀏覽器上一頁/下一頁
    if (savedPosition) {
      return savedPosition;
    }

    // 一般切頁回到頂部
    return { top: 0 };
  },
});

export default router;
